import { C, F } from './SiteChrome';
import { useCountdown } from '../lib/useCountdown';

import { CHALLENGE_STARTS, CHALLENGE_CLOSES } from '../lib/challengeDates';

export { CHALLENGE_STARTS, CHALLENGE_CLOSES };

/**
 * The days / hours / mins / secs countdown to the challenge start. Shared by
 * the challenge page and the dashboard so the two always match.
 */
// `wide` stretches the four boxes across the full width with bigger numbers,
// for the top of the challenge page.
const ChallengeCountdown = ({ target = CHALLENGE_STARTS, onDark = true, wide = false }) => {
    const t = useCountdown(target);
    if (t.done) return null;
    const cells = [['days', t.days], ['hours', t.hours], ['mins', t.minutes], ['secs', t.seconds]];
    // The biggest unit still counting is highlighted: days, then hours once
    // under a day, then minutes.
    const lead = Math.max(0, cells.findIndex(([, v]) => v > 0));
    return (
        <div role="timer" aria-label={`${t.days} days ${t.hours} hours until the challenge starts`} style={{ display: 'flex', gap: wide ? 12 : 10, width: wide ? '100%' : undefined }}>
            {cells.map(([label, v], i) => (
                <div key={label} style={{ flex: wide ? 1 : undefined, minWidth: 64, padding: wide ? '18px 8px 14px' : '12px 8px 10px', borderRadius: wide ? 22 : 18, textAlign: 'center', background: i === lead ? '#b8ecce' : onDark ? 'rgba(255,255,255,0.08)' : '#ffffff', border: i === lead ? '1px solid #b8ecce' : onDark ? '1px solid rgba(255,255,255,0.14)' : `1px solid ${C.borderLight}` }}>
                    <div style={{ fontFamily: F.brand, fontSize: wide ? 'clamp(30px, 4vw, 44px)' : 30, fontWeight: 800, lineHeight: 1, color: onDark && i !== lead ? '#ffffff' : C.deep, fontVariantNumeric: 'tabular-nums' }}>
                        {String(v).padStart(2, '0')}
                    </div>
                    <div style={{ marginTop: 6, fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: i === lead ? C.deep : onDark ? C.onDarkMuted : C.bodyOnWhite }}>{label}</div>
                </div>
            ))}
        </div>
    );
};

export default ChallengeCountdown;
